import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import globalStore from '@/store/global';
import { HelperCore } from '@/common/dependencies';
import { SVGPureIcon } from '@/ui';
import navbarStore from '@/store/navbar';
import { useState } from 'react';
import ASRModal from '@/components/microphone/ASRModal';
import cacheStore from '@/store/cache';
import { Tooltip } from 'antd';
import chatStoreManager from '@/store/chat/manager';
import userStore from '@/store/user';
import { useMemo } from 'react';
import { cloneDeep } from 'lodash-es';
import fullScreenModalStore from '@/components/full-screen-modal/store';

export const goSearchHistory = cid => {
  globalStore.gotoSearchPage(cid);
};
/**
 *
 * @param
 * {
 *  prompt:'xxxx',
 *  image_url: 'xxxx',
 *  file: [],
 *  dataset: {},
 * }
 */
export const newSearch = params => {
  HelperCore.log('newSearch',params);
  cacheStore.setData('aisoParams', HelperCore.copyObj(params));

  globalStore.gotoSearchPage("new");
};

const ShareBtn = observer(({ onClick }) => {
  return (
    <div
      className={[
        'flex items-center h-32px',
        'px-16px py-8px',
        'mr-16px text-primary-opacity text-opacity-90 cursor-pointer',
        'rounded-full border-1px border-[rgba(0,0,0,0.16)]',
        'bg-button-bg-normal hover:bg-[rgba(0,0,0,0.03)]',
      ]}
      onClick={onClick}
    >
      <SVGPureIcon name="chat_share_v2" className={`size-16px`} />
      <span className="ml-4px text-14px">分享</span>
    </div>
  );
});

const BackBtn = observer(() => {
  return (
    <Tooltip title="返回">
      <div
        className={`size-32px flex items-center justify-center rounded-8px hover:bg-black hover:bg-opacity-3 cursor-pointer ${navbarStore.isCollapse ? 'ml-60px' : ''}`}
        onClick={() => {
          globalStore.gotoSearchHome(true);
        }}
      >
        <SVGPureIcon
          name="header_back_arrow"
          className={`size-24px text-black hover:text-[#333]`}
        />
      </div>
    </Tooltip>
  );
});

const SearchPage = observer(({ id }) => {
  const [showShare, setShowShare] = useState(false);
  const iframeRef = useRef(null);

  const handleSearch = id => {
    if (!id) return;
    //发起搜索
    if (id == 'new') {
      setShowShare(false);
      const params = cacheStore.getData('aisoParams');
      HelperCore.log('handleSearch-params', params);
      iframeRef?.current?.contentWindow?.postMessage(
        {
          action: 'newSearch',
          data: params,
        },
        '*'
      );
    } else {
      //去搜索结果页
      iframeRef?.current?.contentWindow?.postMessage(
        {
          action: 'searchHistory',
          data: { cid: id },
        },
        '*'
      );
    }
  };

  const handleMessage = async ({ data }) => {
    if (!data || !(data instanceof Object)) {
      return;
    }
    // HelperCore.log('handleMessage', data);
    const { data: message, action } = data || {};
    const { cid, shareReady, prompt, dataset, file } = message || {};
    switch (action) {
      case 'openASRModal':
        const input = await ASRModal.open();
        iframeRef?.current?.contentWindow?.postMessage(
          {
            action: 'closeASRModal',
            data: { input },
          },
          '*'
        );
        break;
      case 'mcpSearch':
        userStore.doWhenLogin(()=>{
          chatStoreManager.newChat({ field_category: 'auto', input: prompt, dataset, file });
        });
        break;
      case 'searchReady':
        // if(globalStore.searchReady) return;
        // globalStore.setData('searchReady', true);
        handleSearch(id);
        break;
      case 'searchCid': //更新同步cid
        globalStore.gotoSearchPage(cid, true);
        setTimeout(() => {
          navbarStore.getHistory(true);
        }, 2000);
        break;
      case 'deleteCid':
        if(location.pathname == `/search/${cid}`){
          globalStore.navigate("/");
        }
        navbarStore.deleteHistoryItem(cid);
        break;
      case 'shareReady':
        setShowShare(true);
        navbarStore.getHistory(true);
        break;
      case 'beforeOpenModal':
        navbarStore.setIsCollapse(true);
        globalStore.setShowChildIFrameModal(true);
        break;
      case 'afterCloseModal':
        globalStore.setShowChildIFrameModal(false);
        break;
      case 'qaSDKTrigger':
        userStore.qaSDKTrigger(message);
        break;
      case 'gotoLogin':
        userStore.gotoLogin();
        break;
      case 'openFullModal':
        fullScreenModalStore.setData(message)
        break;
      case 'openImageViewer_aiso':
        // 响应搜索页面图片查看器的全屏化
        console.info('openImageViewer_aiso', message);
        if (message?.open) {
          // 全屏化
          fullscreen_aiso()
        } else {
          // 退出全屏化
          exitFullscreen_aiso()
        }
      default:
        break;
    }
  };
  // 用完之后一定要还原状态！
  const [isAiSoFullscreen, setIsAiSoFullscreen] = useState(false);
  const [isBlackCover, setIsBlackCover] = useState(false);
  /** 缓存进入页面时候的导航折叠状态 */
  const navbarIsCollapseRef = useRef(cloneDeep(navbarStore.isCollapse));
  // 搜索页面图片查看器的全屏化
  const fullscreen_aiso = () => {
    setIsAiSoFullscreen(true)
    setIsBlackCover(true)
    navbarStore.setIsCollapse(true)
    document.getElementById('ASSISTANT_SEARCH_WRAPPER_HEADER').style.display = 'none'
    document.getElementById('ASSISTANT_SEARCH_HOME_WRAPPER').style.zIndex = '999'
    setTimeout(() => {
      setIsBlackCover(false)
    }, 200 /** pending 时间 */)
  }
  // 搜索页面图片查看器的退出全屏化
  const exitFullscreen_aiso = () => {
    setIsAiSoFullscreen(false)
    navbarStore.setIsCollapse(false)
    document.getElementById('ASSISTANT_SEARCH_WRAPPER_HEADER').style.display = 'block'
    document.getElementById('ASSISTANT_SEARCH_HOME_WRAPPER').style.zIndex = ''
  }

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
      // 退出页面后恢复缓存的折叠状态
      // navbarStore.setIsCollapse(navbarIsCollapseRef.current)
    };
  }, []);

  useEffect(()=>{
    globalStore.setSearchIFrameRef(iframeRef);
  }, [iframeRef.current])

  useEffect(() => {
    if (!id) return;
    handleSearch(id);

    return () => {};
  }, [id]);

  // 添加一个方法用于根据url判断是否本地环境
  const isLocal = useMemo(() => {
    return window.location.hostname.includes('local')
  }, [])

  const renderModal = () => {
    // if (!globalStore.showChildIFrameModal) {
    //   return null;
    // }
    if (globalStore.showChildIFrameModal || isBlackCover) {
      return (
        <div
        className={[
          'absolute top-0 left-0 right-0 bottom-0 bg-black bg-opacity-45',
          isBlackCover ? 'z-999 bg-opacity-88' : '',
        ]}
        onClick={() => {
          iframeRef?.current?.contentWindow?.postMessage(
            {
              action: 'closeModal',
              data: {},
            },
            '*'
          );
        }}
      ></div>
      )
    }
  }
  return (
    <div className="size-full flex flex-col">
      <div className="pl-16px pr-20px pt-16px pb-12px bg-primary relative" id="ASSISTANT_SEARCH_WRAPPER_HEADER">
        <div className="h-40px flex justify-between items-center">
          <BackBtn />
          <div className="flex items-center ml-auto">
            {showShare ? (
              <ShareBtn
                onClick={evt => {
                  navbarStore.setIsCollapse(true);
                  iframeRef?.current?.contentWindow?.postMessage(
                    {
                      action: 'openShare',
                      data: {},
                    },
                    '*'
                  );
                }}
              />
            ) : null}
          </div>
        </div>

      </div>
      {renderModal()}
      <div
        className={[
          'w-full mx-auto h-0 flex-grow relative',
          isAiSoFullscreen ? '' : 'w-full',
        ]}
      >
        <iframe
          ref={iframeRef}
          allow="camera *;microphone *;clipboard-write"
          // src={isLocal ? `https://local.360.cn:3000/bot-iframe?src=bot_search` : `${import.meta.env.VITE_AISO_HOST}/bot-iframe?src=bot_search`}
          src={`${import.meta.env.VITE_AISO_HOST}/bot-iframe?src=bot_search`}
          // src={`https://local.360.cn:3000/bot-iframe?src=bot_search`}
          className="size-full"
        />
      </div>
    </div>
  );
});
export default SearchPage;
